module.exports = __webpack_public_path__ + "media/components/assets/dabang_bottle_01-07a5ff0146f26a30d93bbd06874bb173.png";